// extracted by mini-css-extract-plugin
export default {"grid":"Contato_grid__Gllm1","container":"Contato_container__irvWg","link":"Contato_link__SrDlZ","grid3Item":"Contato_grid3Item__ejKPg"};